import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer00341 = new TileLayer({
  title: 'Máscara 19960927',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19961130l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00341.setVisible(false);

const layer00340 = new TileLayer({
  title: 'Máscara 19961130',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19961130l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00340.setVisible(false);

const layer00339 = new TileLayer({
  title: 'Máscara 19970218',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19970218l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00339.setVisible(false);

const layer00338 = new TileLayer({
  title: 'Máscara 19970306',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19970306l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00338.setVisible(false);

const layer00337 = new TileLayer({
  title: 'Máscara 19970509',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19970509l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00337.setVisible(false);

const layer00336 = new TileLayer({
  title: 'Máscara 19970626',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19970626l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00336.setVisible(false);

const layer00335 = new TileLayer({
  title: 'Máscara 19970712',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19970712l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00335.setVisible(false);

const layer00334 = new TileLayer({
  title: 'Máscara 19970728',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19970728l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00334.setVisible(false);

const layer00333 = new TileLayer({
  title: 'Máscara 19970813',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19970813l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00333.setVisible(false);

const layer00332 = new TileLayer({
  title: 'Máscara 19970829',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19970829l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00332.setVisible(false);

export const grupoCapa01_25 = new LayerGroup({
  title: 'Ciclo Hidrológico 1996-1997',
  fold: 'close',
  layers: [layer00332, layer00333, layer00334, layer00335, layer00336, layer00337, layer00338, layer00339, layer00340, layer00341]
});